// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2IYn5","questions":"styles_questions__2ph_Q","footer":"styles_footer__xETN3"};